import axios from 'axios'
import store from '../store'
import { services } from '../services'
import { getConfig } from '@/services/runtimeConfig'

const instance = axios.create({
  headers: {
    requestOrigin: 'DASHBOARD_PARTNER'
  }
})

const _appendResponse = (response, stack = null) => services.errorService(response)

// Runtime config (settings.json) loads async on bootstrap, so the API host is
// only available once requests fire. Resolve it once on the first request and
// reuse it — runtime config can't change without a redeploy.
let runtimeBaseURL

instance.interceptors.request.use(config => {
  if (runtimeBaseURL === undefined) runtimeBaseURL = getConfig('VUE_APP_API_HOST')
  config.baseURL = runtimeBaseURL

  const showLoader = store.getters['loading/isFullPage']
  if (showLoader) store.dispatch('loading/start')

  if (store) config.headers['Authorization'] = store.getters['user/authorization']
  return config
})

instance.interceptors.response.use(response => {
  store.dispatch('loading/stop')
  return _appendResponse(response)
}, error => {
  store.dispatch('loading/stop')

  // TODO: pick up the error.stack for logs
  return _appendResponse(error.response)
})

export default instance



// WEBPACK FOOTER //
// ./src/repository/http.js